module.exports = __webpack_public_path__ + "media/images/bg/shapes/workshops-7c9115b69397751a8a099996d7a59958.svg";